if (typeof window !== 'undefined' && window.LLpublicPath)
  // eslint-disable-next-line no-undef, camelcase
  __webpack_public_path__ = window.LLpublicPath
